<template>
    <div>
        <div class="banner">
            <img
                :src="require('../../../../assets/img/product/product_banner_'+productList[currentIndex].img+'.png')" />
        </div>
        <div class="menu">
            <el-menu :default-active="currentIndex.toString()" class="nav clearfix" mode="horizontal">
                <el-menu-item :index="index.toString()" @click="jumpPage('/product/' + (index + 1))" class="cursor-pointer"
                    v-for="(item, index) in productList" :key="index">
                    {{ item.name }}
                </el-menu-item>
            </el-menu>
        </div>
        <digital v-if="currentIndex==1"></digital>
        <energy v-else-if="currentIndex==2"></energy>
        <robot v-else-if="currentIndex==3"></robot>
        <jidian v-else-if="currentIndex==4"></jidian>
        <building v-else-if="currentIndex==5"></building>
        <fmcs v-else></fmcs>
    </div>
</template>

<script>
import fmcs from './productDetail/fmcs.vue';
import digital from './productDetail/digital.vue';
import energy from './productDetail/energy.vue';
import robot from './productDetail/robot.vue';
import jidian from './productDetail/jidian.vue';
import building from './productDetail/building.vue';
export default {
    components:{
        fmcs,
        digital,
        energy,
        robot,
        jidian,
        building
    },
    props: ['id'],
    data(){
        return {
            currentIndex:0,
            productList:[{name:'设备监控系统(FMCS)',img:'fmcs'},{name:'园区及企业数字化系统',img:'digital'},{name:'节能减排与能源管理',img:'energy'},{name:'工业机器人系统集成',img:'robot'},{name:'机电安装',img:'jidian'},{name:'建筑智能化系统',img:'building'}],            
            autoSwitchProductTimer: null, // 自动切换产品定时器
            autoSwitchProductInterval: 10000, // 切换间隔（10秒）
            isAtTop: true
        }
    },
    methods:{
        isNumber(value) {
            if (typeof value === 'number') {
                return !isNaN(value);
            }
            if (typeof value === 'string') {
                const trimmed = value.trim();
                return !isNaN(trimmed) && isFinite(trimmed);
            }
            return false;
        },
        jumpPage(url) {
            this.$router.push(url)
        },
        startAutoSwitchProduct(){
            if (this.productList.length <= 1) return; // 如果菜单项少于2个，不启动自动切换
            this.autoSwitchProductTimer = setInterval(() => {
                if(this.isAtTop)
                    this.currentIndex = (this.currentIndex + 1) % this.productList.length;
            }, this.autoSwitchProductInterval);
        },
        stopAutoSwitchProduct() {
            if (this.autoSwitchProductTimer) {
                clearInterval(this.autoSwitchProductTimer);
                this.autoSwitchProductTimer = null;
            }
        },
        handleScroll() {
            // 获取当前滚动位置
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;

            // 判断是否滚动到顶部
            this.isAtTop = scrollPosition === 0;
        }
    },
    mounted() {
        if(this.id&&this.isNumber(this.id)&&this.id>0&&this.id<=this.productList.length)
            this.currentIndex=(this.id-1)

        // 页面加载后启动项目案例自动切换
        this.startAutoSwitchProduct();

        // 添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        // 组件销毁时清除定时器
        this.stopAutoSwitchProduct();

        // 移除滚动事件监听，避免内存泄漏
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style lang="less" scoped>
@import '@/assets/css/product.less';
</style>